import React from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import FolderSharedOutlinedIcon from '@mui/icons-material/FolderSharedOutlined';
import { Modal } from '@/core/features/modal';
import { Snackbar } from '@/core/features/snackbar';
import { Loader } from '@/core/features/loader';
import AuthHeader from '@/components/AuthHeader';
import Sidebar from '@/components/Sidebar';
import styles from './styles';

const SIDEBAR_ITEMS = [
  { path: '/', label: 'GameDay', icon: <LiveTvIcon /> },
  { path: '/add-game', label: 'Προσθήκη αγώνα', icon: <AddBoxOutlinedIcon /> },
  { path: '/teams', label: 'Ομάδες', icon: <FolderSharedOutlinedIcon /> },
];

const RootLayout = () => (
  <>
    <Modal />
    <Snackbar />
    <Loader />
    <AuthHeader />

    <Box sx={styles.root}>
      <Sidebar items={SIDEBAR_ITEMS} liveEditors mode="dark" />

      <Box sx={styles.main} component="main">
        <Outlet />
      </Box>

      <Sidebar events mode="light" />
    </Box>
  </>
);

export default RootLayout;
